import { RecentDiscovery } from 'types/creator-discovery';

interface RecentDiscoveryItemProps {
    discovery: RecentDiscovery;
    isActive: boolean;
    onClick: () => void;
}

const RecentDiscoveryItem = ({ discovery, isActive, onClick }: RecentDiscoveryItemProps) => {
    return (
        <button
            type="button"
            className={`recent-discovery-item ${isActive ? 'recent-discovery-item--active' : ''}`}
            onClick={onClick}
        >
            <div className="recent-discovery-item__content">
                <p className="recent-discovery-item__query">{discovery.query}</p>
                <span className="recent-discovery-item__date">{discovery.created}</span>
            </div>
            <i className="ri-arrow-right-s-line recent-discovery-item__chevron" />
        </button>
    );
};

export default RecentDiscoveryItem;
